import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import { AdminAuthProvider, useAdminAuth } from "@/context/AdminAuthContext";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminBlog from "@/pages/AdminBlog";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ApplySuccess from "@/pages/ApplySuccess";
import ApplyCancelled from "@/pages/ApplyCancelled";

function ProtectedAdmin({ children }) {
  const { admin, loading } = useAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-mtk-bg" data-testid="admin-loading">
        <div className="text-mtk-gold font-mono-mtk text-xs tracking-[0.3em]">
          LOADING...
        </div>
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  useEffect(() => {
    document.title = "MTK SYSTEM · Mindset · Training · Knowledge";
  }, []);

  return (
    <LangProvider>
      <AdminAuthProvider>
        <div className="App bg-mtk-bg text-white min-h-screen">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/apply/success" element={<ApplySuccess />} />
              <Route path="/apply/cancelled" element={<ApplyCancelled />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedAdmin>
                    <AdminDashboard />
                  </ProtectedAdmin>
                }
              />
              <Route
                path="/admin/blog"
                element={
                  <ProtectedAdmin>
                    <AdminBlog />
                  </ProtectedAdmin>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#121212",
                color: "#FFFFFF",
                border: "1px solid #27272A",
                borderRadius: "2px",
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
        </div>
      </AdminAuthProvider>
    </LangProvider>
  );
}

export default App;
